import { Rss, Users } from "lucide-react";
import { LINKS } from "@/lib/site";

const Hero = () => (
  <section id="home" data-testid="hero-section" className="relative overflow-hidden bg-ink">
    <img
      src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=2000&q=80"
      alt=""
      aria-hidden
      className="absolute inset-0 h-full w-full object-cover"
      loading="eager"
    />
    <div
      aria-hidden
      className="absolute inset-0"
      style={{
        background:
          "linear-gradient(180deg, rgba(10,10,11,0.8) 0%, rgba(10,10,11,0.68) 50%, rgba(10,10,11,0.97) 100%)",
      }}
    />
    <div aria-hidden className="dot-grid absolute inset-0 opacity-40" />

    <div className="relative mx-auto max-w-7xl px-5 pb-10 pt-24 lg:px-10 lg:pb-14 lg:pt-32">
      <div className="flex items-center gap-4">
        <img
          src="/jgw-logo.jpeg"
          alt="Jewish Global Wire"
          data-testid="hero-logo-image"
          className="h-12 w-12 rounded-full object-cover ring-2 ring-white/25 lg:h-14 lg:w-14"
        />
        <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.25em] text-silver-light">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-whatsapp opacity-70" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-whatsapp" />
          </span>
          Live Updates
        </span>
      </div>

      <h1 className="mt-5 max-w-3xl font-display text-3xl font-bold leading-[1.12] tracking-tight text-white sm:text-4xl lg:text-5xl">
        Jewish News. Directly on <span className="text-whatsapp">WhatsApp.</span>
      </h1>

      <p className="mt-4 max-w-2xl text-sm leading-relaxed text-silver-light md:text-base">
        Important Jewish, Israel, and worldwide updates—delivered directly
        through the JGW WhatsApp community and status.
      </p>

      <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:gap-4">
        <a
          href={LINKS.community}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="hero-join-community-button"
          className="inline-flex items-center justify-center gap-2.5 rounded-xl bg-whatsapp px-6 py-3.5 text-sm font-bold text-white shadow-[0_12px_32px_-8px_rgba(37,211,102,0.5)] transition-all duration-200 hover:-translate-y-0.5 hover:bg-whatsapp-dark"
        >
          <Users size={17} strokeWidth={2.2} />
          Join Our Community
        </a>
        <a
          href={LINKS.status}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="hero-subscribe-status-button"
          className="inline-flex items-center justify-center gap-2.5 rounded-xl border border-white/35 bg-white/5 px-6 py-3.5 text-sm font-bold text-white backdrop-blur transition-all duration-200 hover:-translate-y-0.5 hover:bg-white hover:text-black"
        >
          <Rss size={17} strokeWidth={2.2} />
          Subscribe to Our Status
        </a>
      </div>

      <p className="mt-6 flex items-center gap-4 text-[11px] font-bold uppercase tracking-[0.35em] text-silver">
        <span className="h-px w-10 bg-white/25" />
        Jewish • Israel • Worldwide
      </p>
    </div>
  </section>
);

export default Hero;
